/**
 * @generated SignedSource<<1c50082d49d4fa43e50f23d89248bc32>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type VirtualAgentIntentTemplateType = "DISCOVERED" | "SHARED" | "STANDARD" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type intentTemplate_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar$data = {
  readonly description: string | null | undefined;
  readonly id: string;
  readonly name: string;
  readonly type: VirtualAgentIntentTemplateType;
  readonly " $fragmentSpreads": FragmentRefs<"templateDialog_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar">;
  readonly " $fragmentType": "intentTemplate_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar";
};
export type intentTemplate_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar$key = {
  readonly " $data"?: intentTemplate_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar$data;
  readonly " $fragmentSpreads": FragmentRefs<"intentTemplate_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "intentTemplate_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "kind": "ScalarField",
      "name": "description"
    },
    {
      "kind": "FragmentSpread",
      "name": "templateDialog_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar"
    }
  ],
  "type": "VirtualAgentIntentTemplate"
};

(node as any).hash = "f5eec250ceff0cf077da9b8d4b794c86";

export default node;
